class EtolieFooter extends HTMLElement {
  connectedCallback() {
    if (this._footerMedia) return;

    this._footerDetails = [...this.querySelectorAll('[data-etolie-foot-acc]')];
    // Phone and tablet use the same compact disclosure pattern. Keeping every
    // long navigation group expanded at 768px made the footer taller than the
    // viewport and broke the otherwise quiet page rhythm.
    this._footerMedia = window.matchMedia('(max-width: 1149px)');
    this._syncFooterDetails = (event) => {
      this._footerDetails.forEach((details) => {
        details.open = !event.matches;
      });
    };

    // Przełącznik kraju i języka nie ma widocznego przycisku „Zastosuj”:
    // wybór z natywnej listy od razu wysyła formularz lokalizacji.
    this.querySelectorAll('.etolie-foot__loc select').forEach((select) => {
      select.addEventListener('change', () => {
        const form = select.form;
        if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    });

    this._syncFooterDetails(this._footerMedia);
    if (this._footerMedia.addEventListener) {
      this._footerMedia.addEventListener('change', this._syncFooterDetails);
    } else {
      this._footerMedia.addListener(this._syncFooterDetails);
    }
  }

  disconnectedCallback() {
    if (!this._footerMedia || !this._syncFooterDetails) return;

    if (this._footerMedia.removeEventListener) {
      this._footerMedia.removeEventListener('change', this._syncFooterDetails);
    } else {
      this._footerMedia.removeListener(this._syncFooterDetails);
    }

    this._footerMedia = null;
    this._footerDetails = [];
  }
}

if (!customElements.get('etolie-footer')) {
  customElements.define('etolie-footer', EtolieFooter);
}
